
// 未安装插件弹层提示重新加载弹层modal
export const NO_INSTALL_MODAL_RELOAD = 'NO_INSTALL_MODAL_RELOAD';

// 安装插件弹层
export const NO_INSTALL_MODAL = 'NO_INSTALL_MODAL';
